export default "__VITE_ASSET__B08l_17q__"